import { useState, useEffect } from 'react'
import { VITE_API_BASE } from '../config/apiConfig'

const API = VITE_API_BASE

const CHANNEL_TYPES = [
  { value: '自然流量', label: '自然流量' },
  { value: '合作推广', label: '合作推广' },
  { value: '广告投放', label: '广告投放' },
  { value: '地推', label: '地推' },
  { value: '社交媒体', label: '社交媒体' },
  { value: '线下活动', label: '线下活动' },
]

export default function Channels() {
  const [channels, setChannels] = useState([])
  const [stats, setStats] = useState({ total: 0, activeCount: 0, totalStudents: 0, totalParticipants: 0, totalAppointments: 0, totalRevenue: 0 })
  const [loading, setLoading] = useState(true)
  const [modalVisible, setModalVisible] = useState(false)
  const [editingChannel, setEditingChannel] = useState(null)
  const [form, setForm] = useState({ name: '', type: '自然流量', description: '', contactPerson: '', contactPhone: '', url: '', promoCode: '', status: 'active' })

  useEffect(() => {
    loadData()
  }, [])

  const loadData = () => {
    setLoading(true)
    fetch(`${API}/channels/stats`)
      .then(r => r.json())
      .then(d => {
        if (d.success) {
          setChannels(d.data.list || [])
          setStats(d.data)
        }
      })
      .catch(err => console.error('加载失败', err))
      .finally(() => setLoading(false))
  }

  const handleAdd = () => {
    setEditingChannel(null)
    setForm({ name: '', type: '自然流量', description: '', contactPerson: '', contactPhone: '', url: '', promoCode: '', status: 'active' })
    setModalVisible(true)
  }

  const handleEdit = (channel) => {
    setEditingChannel(channel)
    setForm({
      name: channel.name,
      type: channel.type,
      description: channel.description || '',
      contactPerson: channel.contactPerson || '',
      contactPhone: channel.contactPhone || '',
      url: channel.url || '',
      promoCode: channel.promoCode || '',
      status: channel.status
    })
    setModalVisible(true)
  }

  const handleDelete = async (id) => {
    if (!confirm('确定要删除这个渠道吗？')) return
    try {
      const res = await fetch(`${API}/channels/${id}`, { method: 'DELETE' })
      const data = await res.json()
      if (data.success) {
        loadData()
      } else {
        alert(data.error || '删除失败')
      }
    } catch (err) {
      alert('删除失败')
    }
  }

  const handleSubmit = async () => {
    if (!form.name.trim()) {
      alert('请输入渠道名称')
      return
    }
    try {
      const url = editingChannel ? `${API}/channels/${editingChannel.id}` : `${API}/channels`
      const method = editingChannel ? 'PUT' : 'POST'
      const res = await fetch(url, {
        method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form)
      })
      const data = await res.json()
      if (data.success) {
        setModalVisible(false)
        loadData()
      } else {
        alert(data.error || '保存失败')
      }
    } catch (err) {
      alert('保存失败')
    }
  }

  const updateForm = (key, value) => {
    setForm({ ...form, [key]: value })
  }

  return (
    <div style={{ padding: 24 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <div>
          <h2 style={{ fontSize: 20, margin: 0 }}>📢 渠道管理</h2>
          <p style={{ color: '#666', margin: '4px 0 0', fontSize: 13 }}>管理推广渠道，追踪用户来源和转化效果</p>
        </div>
        <button onClick={handleAdd} style={{ padding: '10px 20px', background: '#1890ff', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 14 }}>
          + 添加渠道
        </button>
      </div>

      {/* 统计卡片 */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 16, marginBottom: 24 }}>
        <div style={card}>
          <div style={{ color: '#999', fontSize: 12 }}>渠道总数</div>
          <div style={{ fontSize: 28, color: '#1890ff' }}>{loading ? '-' : stats.activeCount}</div>
        </div>
        <div style={card}>
          <div style={{ color: '#999', fontSize: 12 }}>覆盖学员</div>
          <div style={{ fontSize: 28, color: '#52c41a' }}>{loading ? '-' : stats.totalStudents}</div>
        </div>
        <div style={card}>
          <div style={{ color: '#999', fontSize: 12 }}>活动报名</div>
          <div style={{ fontSize: 28, color: '#fa8c16' }}>{loading ? '-' : stats.totalParticipants}</div>
        </div>
        <div style={card}>
          <div style={{ color: '#999', fontSize: 12 }}>带来收入</div>
          <div style={{ fontSize: 28, color: '#722ed1' }}>¥{loading ? '-' : stats.totalRevenue?.toLocaleString()}</div>
        </div>
      </div>

      {/* 渠道列表 */}
      <div style={{ background: '#fff', borderRadius: 8, overflow: 'hidden', boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }}>
        {loading ? (
          <div style={{ padding: 40, textAlign: 'center', color: '#666' }}>加载中...</div>
        ) : channels.length === 0 ? (
          <div style={{ padding: 40, textAlign: 'center', color: '#666' }}>
            暂无渠道数据<br />
            <button onClick={handleAdd} style={{ marginTop: 16, padding: '8px 16px', background: '#1890ff', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer' }}>
              添加第一个渠道
            </button>
          </div>
        ) : (
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ background: '#fafafa' }}>
                {['渠道名称', '类型', '推广码', '学员', '报名', '收入', '状态', '操作'].map(h => (
                  <th key={h} style={{ padding: 12, textAlign: 'center', fontSize: 13, color: '#999', fontWeight: 500 }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {channels.map(c => (
                <tr key={c.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                  <td style={{ ...td, fontWeight: 600 }}>{c.name}</td>
                  <td style={{ ...td, textAlign: 'center' }}>
                    <span style={{ padding: '2px 8px', borderRadius: 10, fontSize: 11, background: getTypeColor(c.type), color: '#fff' }}>
                      {c.type}
                    </span>
                  </td>
                  <td style={{ ...td, textAlign: 'center', fontFamily: 'monospace', fontSize: 12 }}>{c.promoCode || '-'}</td>
                  <td style={{ ...td, textAlign: 'center', color: '#666' }}>{c.students || 0}</td>
                  <td style={{ ...td, textAlign: 'center', color: '#666' }}>{c.participants || 0}</td>
                  <td style={{ ...td, textAlign: 'center', fontWeight: 600, color: '#52c41a' }}>¥{c.revenue?.toLocaleString() || 0}</td>
                  <td style={{ ...td, textAlign: 'center' }}>
                    <span style={{ padding: '2px 8px', borderRadius: 10, fontSize: 11, background: c.status === 'active' ? '#52c41a' : '#999', color: '#fff' }}>
                      {c.status === 'active' ? '活跃' : '停用'}
                    </span>
                  </td>
                  <td style={{ ...td, textAlign: 'center' }}>
                    <button onClick={() => handleEdit(c)} style={{ marginRight: 8, padding: '4px 8px', background: 'none', border: '1px solid #d9d9d9', borderRadius: 4, cursor: 'pointer', fontSize: 12 }}>编辑</button>
                    <button onClick={() => handleDelete(c.id)} style={{ padding: '4px 8px', background: 'none', border: '1px solid #ff4d4f', borderRadius: 4, cursor: 'pointer', fontSize: 12, color: '#ff4d4f' }}>删除</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {/* 添加/编辑弹窗 */}
      {modalVisible && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ background: '#fff', borderRadius: 12, padding: 24, width: 480, maxHeight: '80vh', overflowY: 'auto' }}>
            <h3 style={{ margin: '0 0 20px', fontSize: 18 }}>{editingChannel ? '编辑渠道' : '添加渠道'}</h3>
            
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', marginBottom: 6, fontSize: 13, color: '#666' }}>渠道名称 *</label>
              <input type="text" value={form.name} onChange={e => updateForm('name', e.target.value)} placeholder="请输入渠道名称" style={inputStyle} />
            </div>

            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', marginBottom: 6, fontSize: 13, color: '#666' }}>渠道类型</label>
              <select value={form.type} onChange={e => updateForm('type', e.target.value)} style={inputStyle}>
                {CHANNEL_TYPES.map(t => <option key={t.value} value={t.value}>{t.label}</option>)}
              </select>
            </div>

            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', marginBottom: 6, fontSize: 13, color: '#666' }}>推广码</label>
              <input type="text" value={form.promoCode} onChange={e => updateForm('promoCode', e.target.value.toUpperCase())} placeholder="如: WECHAT" style={inputStyle} />
            </div>

            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', marginBottom: 6, fontSize: 13, color: '#666' }}>描述说明</label>
              <input type="text" value={form.description} onChange={e => updateForm('description', e.target.value)} placeholder="渠道描述" style={inputStyle} />
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 16 }}>
              <div>
                <label style={{ display: 'block', marginBottom: 6, fontSize: 13, color: '#666' }}>联系人</label>
                <input type="text" value={form.contactPerson} onChange={e => updateForm('contactPerson', e.target.value)} placeholder="联系人姓名" style={inputStyle} />
              </div>
              <div>
                <label style={{ display: 'block', marginBottom: 6, fontSize: 13, color: '#666' }}>联系电话</label>
                <input type="tel" value={form.contactPhone} onChange={e => updateForm('contactPhone', e.target.value)} placeholder="手机号" style={inputStyle} />
              </div>
            </div>

            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', marginBottom: 6, fontSize: 13, color: '#666' }}>状态</label>
              <select value={form.status} onChange={e => updateForm('status', e.target.value)} style={inputStyle}>
                <option value="active">活跃</option>
                <option value="inactive">停用</option>
              </select>
            </div>

            <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end' }}>
              <button onClick={() => setModalVisible(false)} style={{ padding: '10px 20px', background: '#f5f5f5', border: 'none', borderRadius: 6, cursor: 'pointer' }}>
                取消
              </button>
              <button onClick={handleSubmit} style={{ padding: '10px 20px', background: '#1890ff', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer' }}>
                保存
              </button>
            </div>
          </div>
        </div>
      )}

      <div style={{ marginTop: 16, fontSize: 12, color: '#999' }}>
        💡 渠道数据可对接活动报名、预约咨询等表单的「来源渠道」字段，自动统计转化效果
      </div>
    </div>
  )
}

const card = { background: '#fff', borderRadius: 8, padding: 16, boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }
const td = { padding: 12, fontSize: 13 }
const inputStyle = { width: '100%', padding: '10px 12px', border: '1px solid #d9d9d9', borderRadius: 6, fontSize: 14, boxSizing: 'border-box' }

const getTypeColor = (type) => {
  const colors = {
    '自然流量': '#1890ff',
    '合作推广': '#52c41a',
    '广告投放': '#fa8c16',
    '地推': '#722ed1',
    '社交媒体': '#eb2f96',
    '线下活动': '#13c2c2'
  }
  return colors[type] || '#999'
}
